import { createContext, useContext } from 'react'

import type { DisplayScale } from './useDisplayScale.js'

export interface ScaleChoice {
  readonly scale: DisplayScale
  readonly choose: (scale: DisplayScale) => void
}

/**
 * The one copy of how big everything is.
 *
 * It used to be a hook with its own `useState` in each component that wanted
 * it — the layout, the key legend, the race track — which was fine while the
 * only way to set it was a query string read once at startup. A switch on the
 * profile page changes that: three components holding three copies means
 * choosing a size moves one of them.
 *
 * Null outside a provider, and `useDisplayScale` falls back to reading the URL
 * and storage itself. That is not a nicety: the host display mounts its own
 * layout without this provider, and it is a television by definition rather
 * than by choice.
 */
export const ScaleContext = createContext<ScaleChoice | null>(null)

export function useScaleChoice(): ScaleChoice | null {
  return useContext(ScaleContext)
}
